// import React, { useEffect, useState } from "react";
// import { fetchQueueDetails, fetchQueueList } from "../../../store/queueSlice";
// import { useDispatch } from "react-redux";
// import { useSelector } from "react-redux";
// import LdsRoller from "../../../utils/LdsRoller";

// const QueueList = ({ queueSearchTerm ,selectedStatus,selectedPriority }) => {
//   const queuesList = useSelector((state) => state.queue.queueListData);
//   const searchedQueueList = useSelector((state) => state.queue.searchedData);
//   const [currentQueuePage, setCurrentQueuePage] = useState(1);
//   const filteredQueueData = useSelector(
//     (state) => state.queue.filteredQueueData
//   );
//   const loadingList = useSelector((state) => state.queue.loadingList);
//   const loadingQueueSearch=useSelector((state)=>state.queue.loadingQueueSearch);
//   const loadingFilteredData = useSelector(
//     (state) => state.queue.loadingFilteredData
//   );
//   console.log(selectedStatus?.value,selectedPriority,"selectedStatus")
//     console.log(searchedQueueList,"searchedQueueList")
//     console.log(filteredQueueData,"filteredQueueData")
//     console.log(loadingFilteredData,"loadingFilteredData")
//   // const parsedQueuesList=JSON.parse(queuesList.body);
//   const dispatch = useDispatch();
//   useEffect(() => {
//     dispatch(fetchQueueList(currentQueuePage));
//     // console.log("ppppp");
//   }, [dispatch, currentQueuePage]);
//   const fetchQueueData = (id) => {
//     // console.log(id);
//     dispatch(fetchQueueDetails(id));
//   };
//   // console.log(searchedQueueList, filteredQueueData, "detailsss");

//   return (
//     <div className="left-section-queue-list">
//       <div className="d-flex justify-content-between align-items-center">
//         <span className="bold font-small">Speciality</span>
//         <span>{queuesList?.count}</span>
//       </div>
//       {loadingList || loadingFilteredData ||loadingQueueSearch ? (
//         <div className="text-center mt-5">
//           {/* You can replace this with a spinner or animation */}
//           <LdsRoller />
//         </div>
//       ) : selectedStatus?.value && filteredQueueData?.length === 0 ?(
//        <p
//           className="text-center mt-3"
//           style={{ fontSize: "13px", fontWeight: "bold", color: "gray" }}
//         >
//           No Results Found for selected status
//         </p>
//       ):
//       filteredQueueData?.length > 0 ? (
//         filteredQueueData.map((eachData, i) => (
//           <div
//             key={i}
//             className="child-card-section"
//             onClick={() => fetchQueueData(eachData.queue_id)}
//           >
//             <div className="d-flex flex-column">
//               <span style={{ fontSize: "13px", fontWeight: "bold" }}>
//                 {eachData.queue_name}
//               </span>
//               <span style={{ color: "gray", fontSize: "12px" }}>
//                 {eachData.queue_name.slice(0, 4).toUpperCase()}
//               </span>
//             </div>
//             <div
//               className="d-flex flex-column align-items-end"
//               style={{ fontSize: "12px" }}
//             >
//               <span className="priority-label">{eachData.priority}</span>
//             </div>
//           </div>
//         ))
//       ) : queueSearchTerm && searchedQueueList?.length > 0 ? (
//         searchedQueueList.map((eachData, i) => (
//           <div
//             key={i}
//             className="child-card-section"
//             onClick={() => fetchQueueData(eachData.queue_id)}
//           >
//             <div className="d-flex flex-column">
//               <span style={{ fontSize: "13px", fontWeight: "bold" }}>
//                 {eachData.queue_name}
//               </span>
//               <span style={{ color: "gray", fontSize: "12px" }}>
//                 {eachData.queue_name.slice(0, 4).toUpperCase()}
//               </span>
//             </div>
//             <div
//               className="d-flex flex-column align-items-end"
//               style={{ fontSize: "12px" }}
//             >
//               <span className="priority-label">{eachData.priority}</span>
//             </div>
//           </div>
//         ))
//       ) : queuesList?.queues?.length > 0 ? (
//         queuesList.queues.map((eachData, i) => (
//           <div
//             key={i}
//             className="child-card-section"
//             onClick={() => fetchQueueData(eachData.queue_id)}
//           >
//             <div className="d-flex flex-column">
//               <span style={{ fontSize: "13px", fontWeight: "bold" }}>
//                 {eachData.queue_name}
//               </span>
//               <span style={{ color: "gray", fontSize: "12px" }}>
//                 {eachData.queue_name.slice(0, 4).toUpperCase()}
//               </span>
//             </div>
//             <div
//               className="d-flex flex-column align-items-end"
//               style={{ fontSize: "12px" }}
//             >
//               <span className="priority-label">{eachData.priority}</span>
//             </div>
//           </div>
//         ))
//       ) : (
//         <p
//           className="text-center mt-3"
//           style={{ fontSize: "13px", fontWeight: "bold", color: "gray" }}
//         >
//           No Results Found
//         </p>
//       )}
//       <div className="d-flex justify-content-between mt-3 align-items-center">
//         <button
//           className="btn btn-sm btn-outline-primary"
//           onClick={() => setCurrentQueuePage((prev) => Math.max(prev - 1, 1))}
//           disabled={currentQueuePage === 1}
//         >
//           Previous
//         </button>
//         <span style={{fontSize:'13px',color:'#0d6efd'}}>Page {currentQueuePage}</span>
//         <button
//           className="btn btn-sm btn-outline-primary"
//           onClick={() => setCurrentQueuePage((prev) => prev + 1)}
//           disabled={queuesList?.queues?.length < 5} // Disable if less than 5 items
//         >
//           Next
//         </button>
//       </div>
//     </div>
//   );
// };

// export default QueueList;


import React, { useEffect, useState } from "react";
import { fetchQueueDetails, fetchQueueList,clearFilteredQueueData, clearSearchedData } from "../../../store/queueSlice";
import { useDispatch, useSelector } from "react-redux";
import LdsRoller from "../../../utils/LdsRoller";

const QueueList = ({ queueSearchTerm, selectedStatus, selectedPriority,setDisableInput,currentQueuePage,setCurrentQueuePage }) => {
  
  
  const dispatch = useDispatch();

  const queuesList = useSelector((state) => state.queue.queueListData);
  const searchedQueueList = useSelector((state) => state.queue.searchedData);
  const filteredQueueData = useSelector((state) => state.queue.filteredQueueData);
  const loadingList = useSelector((state) => state.queue.loadingList);
  const loadingQueueSearch = useSelector((state) => state.queue.loadingQueueSearch);
  const loadingFilteredData = useSelector((state) => state.queue.loadingFilteredData);
 


  

  const fetchQueueData = (id) => {
    setDisableInput(true);
    dispatch(fetchQueueDetails(id));
  };

//   useEffect(() => {
//   setCurrentQueuePage(1);
// }, [queueSearchTerm, selectedStatus, selectedPriority]);

  
// const filteredQueues = queuesList?.queues?.filter((queue) => {
//   const matchesStatus = selectedStatus?.value
//   ? queue.status.toLowerCase() === selectedStatus.value.toLowerCase()
//   : true;

// const matchesPriority = selectedPriority?.value
//   ? queue.priority.toLowerCase() === selectedPriority.value.toLowerCase()
//   : true;

//   return matchesStatus && matchesPriority;
// }) || [];
const paginatedQueues = queuesList?.queues || [];

  const hasData = 
    filteredQueueData?.data?.length > 0 ||
    (queueSearchTerm && searchedQueueList?.length > 0) ||
    paginatedQueues.length > 0;


  const getDisplayedCount = () => {
    if (loadingList || loadingFilteredData || loadingQueueSearch) {
      return 0;
    }
    
    if (filteredQueueData?.data?.length > 0) {
      return filteredQueueData.length;
    }
    
    if (queueSearchTerm && searchedQueueList?.length > 0) {
      return searchedQueueList.length;
    }
    
    if (paginatedQueues.length > 0) {
      return paginatedQueues.length;
    }
    
    return 0;
  };

  // const showPagination = () => {
  //   const currentData = 
  //     filteredQueueData?.length > 0 ? filteredQueueData :
  //     (queueSearchTerm && searchedQueueList?.length > 0) ? searchedQueueList :
  //     manuallyFilteredQueues.length > 0 ? manuallyFilteredQueues :
  //     null;

  //   return currentData && currentData.length >= 5 && 
  //          !loadingList && !loadingFilteredData && !loadingQueueSearch;
  // };

const showPagination = () => {
  if (
    loadingList ||
    loadingFilteredData ||
    loadingQueueSearch ||
    !hasData 
  ) {
    return false;
  }

  if (filteredQueueData?.data?.length > 0 || (queueSearchTerm && searchedQueueList?.length > 0)) {
    const currentData =
      filteredQueueData?.data?.length > 0
        ? filteredQueueData
        : searchedQueueList?.length > 0
        ? searchedQueueList
        : [];

    return currentData.length >= 5 || currentQueuePage > 1;
  }

  if (paginatedQueues.length > 0) {
    return paginatedQueues.length >= 5 || currentQueuePage > 1;
  }

  const totalCount = queuesList?.count || 0;
  return totalCount > 5 || currentQueuePage > 1;
};

 const hasNoData = 
    !loadingList && 
    !loadingFilteredData && 
    !loadingQueueSearch &&
    filteredQueueData?.data?.length === 0 &&
    (!queueSearchTerm || searchedQueueList?.length === 0) &&
    paginatedQueues.length === 0;
    const totalCount=queuesList?.count;
    const totalPages = Math.ceil(totalCount / 5);
    const isFirstPage = currentQueuePage === 1;
    const isLastPage = currentQueuePage === totalPages;
    useEffect(() => {
      if (selectedStatus || selectedPriority || !queueSearchTerm) {
        dispatch(fetchQueueList({
          pageNumber: currentQueuePage,
          selectedStatus:selectedStatus.value,
          selectedPriority,
        }));
      }
    }, [dispatch, currentQueuePage, selectedStatus, selectedPriority]);
useEffect(() => {
  dispatch(clearFilteredQueueData());
  dispatch(clearSearchedData());

  // Only reset page if not already 1
  setCurrentQueuePage((prev) => (prev !== 1 ? 1 : prev));
}, [queueSearchTerm, selectedStatus, selectedPriority]);



  return (
    <div className="left-section-queue-list">
      <div className="d-flex justify-content-between align-items-center">
        <span className="bold font-small">Speciality</span>
        <span>{getDisplayedCount()}</span>
      </div>
  
      {(loadingList || loadingFilteredData || loadingQueueSearch) ? (
        <div className="text-center mt-5">
          <LdsRoller />
        </div>
      ) : queuesList?.length===0 ? (
        // Show this when API returned 404 = no records found
        <p className="text-center mt-3" style={{ fontSize: "13px", fontWeight: "bold", color: "gray" }}>
          No Records Found
        </p>
      ) : (selectedStatus?.value || selectedPriority?.value) && filteredQueueData?.data?.length === 0 ? (
        <p className="text-center mt-3" style={{ fontSize: "13px", fontWeight: "bold", color: "gray" }}>
          No Results Found for selected filters
        </p>
      ) : queueSearchTerm && searchedQueueList?.length === 0 ? (
        // Show this if search term is present but no results
        <p className="text-center mt-3" style={{ fontSize: "13px", fontWeight: "bold", color: "gray" }}>
          No Results Found
        </p>
      ) : filteredQueueData?.data?.length > 0 ? (
        filteredQueueData.map((eachData, i) => (
          <QueueCard key={i} data={eachData} fetchQueueData={fetchQueueData} />
        ))
      ) : queueSearchTerm && searchedQueueList?.length > 0 ? (
        searchedQueueList.map((eachData, i) => (
          <QueueCard key={i} data={eachData} fetchQueueData={fetchQueueData} />
        ))
      ) : paginatedQueues.length > 0 ? (
        paginatedQueues.map((eachData, i) => (
          <QueueCard key={eachData.queue_id} data={eachData} fetchQueueData={fetchQueueData} />
        ))
      ) : (
        // Default fallback message
        <p className="text-center mt-3" style={{ fontSize: "13px", fontWeight: "bold", color: "gray" }}>
          No Results Found
        </p>
      )}
  
      {showPagination() && (
        <div className="d-flex justify-content-between mt-3 align-items-center">
          <button
            className={`btn btn-sm ${isFirstPage || hasNoData ? 'btn-outline-secondary' : 'btn-outline-primary'}`}
            onClick={() => setCurrentQueuePage((prev) => Math.max(prev - 1, 1))}
            disabled={isFirstPage || hasNoData}
          >
            Previous
          </button>
  
          <span style={{ fontSize: "13px", color: "#0d6efd" }}>
            Page {currentQueuePage}
          </span>
  
          <button
            className={`btn btn-sm ${isLastPage || hasNoData ? 'btn-outline-secondary' : 'btn-outline-primary'}`}
            onClick={() => setCurrentQueuePage((prev) => prev + 1)}
            disabled={isLastPage || hasNoData}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
  
};


const QueueCard = ({ data, fetchQueueData }) => (
  <div className="child-card-section" onClick={() => fetchQueueData(data.queue_id)}>
    <div className="d-flex flex-column">
      <span style={{ fontSize: "13px", fontWeight: "bold" }}>
        {data.queue_name}
      </span>
      <span style={{ color: "gray", fontSize: "12px" }}>
        {data.queue_name.slice(0, 4).toUpperCase()}
      </span>
    </div>
    <div className="d-flex flex-column align-items-end" style={{ fontSize: "12px" }}>
      <span className="priority-label">{data.priority}</span>
    </div>
  </div>
);

export default QueueList;

